<template>
  <div class="full-height">
    <blog-header></blog-header>
    <intro></intro>
    <blog-list></blog-list>
    <blog-footer></blog-footer>
  </div>
</template>

<script>
  import Intro from '../partials/IntroLarge'
  import BlogHeader from '../partials/Header'
  import BlogList from './BlogList'
  import BlogFooter from '../partials/Footer'

  export default {
    components: {
      BlogHeader,
      Intro,
      BlogFooter,
      BlogList
    }
  }
</script>



// WEBPACK FOOTER //
// PageBlog.vue?614d0c89